import { render, staticRenderFns } from "./HomeButtons.vue?vue&type=template&id=3dde9f34&scoped=true"
import script from "./HomeButtons.vue?vue&type=script&lang=js"
export * from "./HomeButtons.vue?vue&type=script&lang=js"
import style0 from "./HomeButtons.vue?vue&type=style&index=0&id=3dde9f34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dde9f34",
  null
  
)

export default component.exports